// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".member-picture-view{text-align:center}.member-picture-view figure{margin:0}.member-picture-view img{position:relative;width:100px;height:100px;border-radius:100%}.member-picture-view img.no-image{left:10px}.member-picture-view figcaption{font-family:\"GothamSSm-Medium\",Arial,sans-serif;font-size:20px;color:#4a4a4a;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}\n", ""]);
// Exports
module.exports = exports;
